import { getAssets } from "@unisearch/helpers";
import { upperFirstLetter } from "@unisearch/helpers/utils";
import Link from "next/link";
import { FaUniversity } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import styles from "./uni_thumb_grid_box.module.scss";

const UniThumbGridBox = (props) => {
  return (
    <div className={styles.box}>
      <Link legacyBehavior href={props.universityLink}>
        <a>
          <div className={styles.image_wrapper}>
            <img
              src={
                props.featuredImage ||
                getAssets("assets/images/uni-profile/harvard-university.jpg")
              }
              alt={props.featuredImageAlt || "University banner"}
              className={styles.banner}
            />

            {props.logo && (
              <div className={styles.logo_wrapper}>
                <img
                  src={props.logo}
                  alt={props.logoAlt || "University logo"}
                  className={styles.logo}
                />
              </div>
            )}
          </div>
        </a>
      </Link>

      <div className={styles.profile_box_content}>
        <div className={styles.infos}>
          <Link legacyBehavior href={props.universityLink}>
            <a>
              <div className={styles.name}>
                {props.name || "University Name"}
              </div>
            </a>
          </Link>
          <div className={styles.info}>
            <span className={styles.icon}>
              <MdLocationOn />
            </span>
            <span>
              {props.address && <span>{props.address}, </span>}
              {props.city && <span>{props.city}, </span>}
              {props.state && <span>{props.state}, </span>}
              {props.country && <span>{props.country}</span>}
            </span>
          </div>
          <div className={styles.info}>
            <span className={styles.icon}>
              <FaUniversity style={{ marginTop: "-4px" }} />
            </span>
            <span>
              {props.universityType && upperFirstLetter(props.universityType)}{" "}
              University, {props.estd && <span>Estd {props.estd}</span>}
            </span>
          </div>
          <button className={styles.follow}>+ Follow</button>
        </div>

        <div className={styles.links}>
          {props.courseNumber !== 0 && (
            <Link legacyBehavior href={props.courseLink}>
              <a className={styles.all_courses}>
                View all {props.courseNumber} Courses ›
              </a>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default UniThumbGridBox;
